import { useEffect } from 'react';
import { useAppSelector } from 'store/hooks';
import useFetch from 'hooks/useFetch';
import { getPotsAccount } from 'features/pots/actions';
import { selectPotsStatuses } from '../reducers/selectors';
/**
 * This hook provides current (cached) pots account status and onboardingStatus and tries to update it from server.
 */
const useStatus = () => {
    const potsStatuses = useAppSelector(selectPotsStatuses);
    const [, , , fetch] = useFetch({
        muteError: true,
        muteResult: true,
        muteFetching: true,
    });
    useEffect(() => {
        fetch(getPotsAccount());
    }, []);
    return potsStatuses;
};
export default useStatus;
